import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

const ease = [0.76, 0, 0.24, 1];

export default function Loader() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1700);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          key="loader"
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 1.0, ease }}
          className="fixed inset-0 z-[200] bg-cream flex items-center justify-center overflow-hidden"
          data-testid="site-loader"
        >
          <div className="text-center">
            <div className="overflow-hidden">
              <motion.h1
                initial={{ y: "100%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.95, delay: 0.1, ease }}
                className="font-display italic text-6xl md:text-8xl text-ink font-light"
                style={{ fontVariationSettings: '"SOFT" 100' }}
              >
                संकल्प.
              </motion.h1>
            </div>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.2, delay: 0.3, ease }}
              style={{ transformOrigin: "left" }}
              className="mt-8 h-px w-56 mx-auto bg-saffron"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
